import { render, staticRenderFns } from "./exploit.vue?vue&type=template&id=bc5a4964&scoped=true"
import script from "./exploit.vue?vue&type=script&lang=js"
export * from "./exploit.vue?vue&type=script&lang=js"
import style0 from "./exploit.vue?vue&type=style&index=0&id=bc5a4964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5a4964",
  null
  
)

export default component.exports